import cocktailBackground from 'images/cocktail/cocktail-background.png';
import cocktailLiquid from 'images/cocktail/cocktail-liquid.png';

export default {
    PROMO_ACTION_COCKTAIL: {
        BACKGROUND: cocktailBackground,
        LIQUID: cocktailLiquid
    }
};
